import React from "react";
import { IconProps } from "../icon";

export const ReverseRightIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M20 7H10a6 6 0 100 12h10m0-12l-4-4m4 4l-4 4"
    />
  </svg>
);
